import React from 'react';
import { motion } from 'framer-motion';
import { Quote, ArrowDown } from 'lucide-react';
const testimonials = [{
  quote: 'Llevaba meses con un nudo en el estómago cada vez que alguien tocaba la puerta. Esta guía no me quitó el miedo, pero ahora sé qué pasos seguir y eso me da algo de paz.',
  author: 'Ana R.',
  location: 'Houston, TX'
}, {
  quote: 'Mi esposo y yo la leímos juntos un domingo. Nos ayudó a organizar los documentos que teníamos regados y a hablar con nuestros hijos sobre qué hacer en una emergencia. Algo que veníamos posponiendo.',
  author: 'Jorge M.',
  location: 'Los Ángeles, CA'
}, {
  quote: 'No soy de leer mucho, pero esta guía está escrita de forma clara y directa. Me sirvió para entender cosas que ni mi vecina, que lleva 20 años aquí, sabía.',
  author: 'Lucía P.',
  location: 'Chicago, IL'
}];
export function Testimonials() {
  return <section className="py-24 bg-white text-[#1a1a2e]" data-id="element-235">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-236">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-237">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#0c1222] mb-4 uppercase tracking-wide" data-id="element-238">
            Lo Que Dicen Nuestros Lectores y Lectoras
          </h2>
          <p className="text-gray-500 font-sans text-base max-w-xl mx-auto mt-2" data-id="element-239">
            Historias reales de familias que decidieron prepararse.
          </p>
          <div className="w-24 h-1 bg-[#c0392b] mx-auto mt-6" data-id="element-240" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12" data-id="element-241">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.6
        }} className="relative p-8 bg-gray-50 border-l-4 border-[#c0392b] shadow-sm" data-id="element-242">
              <Quote className="absolute top-6 left-6 w-10 h-10 text-[#c0392b]/20 rotate-180" data-id="element-243" />

              <blockquote className="relative z-10 mt-4" data-id="element-244">
                <p className="font-serif text-lg md:text-xl italic text-[#0c1222] leading-relaxed mb-6" data-id="element-245">
                  "{testimonial.quote}"
                </p>
                <footer className="flex flex-col border-t border-gray-200 pt-4" data-id="element-246">
                  <cite className="font-sans font-bold text-[#0c1222] not-italic uppercase tracking-wide text-sm" data-id="element-247">
                    {testimonial.author}
                  </cite>
                  <span className="font-sans text-sm text-gray-500 mt-1" data-id="element-248">
                    {testimonial.location}
                  </span>
                </footer>
              </blockquote>
            </motion.div>)}
        </div>

        {/* Micro-CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4,
        duration: 0.5
      }} className="text-center mt-16" data-id="element-249">
          <p className="text-gray-600 font-sans text-base mb-4" data-id="element-250">
            Únete a las familias que ya dieron el primer paso.
          </p>
          <a href="#pricing" className="inline-flex items-center text-[#c0392b] font-sans font-bold text-sm uppercase tracking-widest hover:underline transition-colors" data-id="element-251">
            <span data-id="element-252">Ver cómo obtener tu guía</span>
            <ArrowDown className="ml-2 w-4 h-4" data-id="element-253" />
          </a>
        </motion.div>
      </div>
    </section>;
}